/** New Relic Browser page action name for auth session events. */
export const NR_AUTH_SESSION_PAGE_ACTION = 'AuthSession'

/** New Relic Browser custom event type for auth session events (NRQL: FROM AuthSession SELECT *). */
export const NR_AUTH_SESSION_CUSTOM_EVENT = 'AuthSession'
